import axios from 'axios'

export const POSTCODE_URL = `${process.env.REACT_APP_API_URL}/PostCodeMatrices`;
export const POSTCODE_PAGINATED_URL = `${process.env.REACT_APP_API_URL}/PostCodeMatrices/Paginated`;

export const getPostCodePaginated = async (
  currentPage: number,
  dataPerPage: number,
  keyWord?: string
) => {
  try {
    return await axios.get(`${POSTCODE_PAGINATED_URL}`, {
      params: {
        PageNumber: currentPage,
        PageSize: dataPerPage,
        keyWord
      },
    })
  } catch (err) {
    return err
  }
}

export const createPostCode = async (payload: any) => {
  try {
    return await axios.post(`${POSTCODE_URL}`, payload)
  } catch (err) {
    return err
  }
}

export const updatePostCode = async (payload: any) => {
  try {
    return await axios.patch(`${POSTCODE_URL}/${payload.Id}`, payload)
  } catch (err) {
    return err
  }
}

export const deletePostCode = async (id: any) => {
  try {
    return await axios.delete(`${POSTCODE_URL}/${id}`)
  } catch (err) {
    return err
  }
}

export const savePostCode = async (postCodeList: any) => {
  try {
    return await axios.post(`${POSTCODE_URL}/upload-postcode`, postCodeList)
  } catch (err) {
    console.log('err', err)
    return err
  }
}

export const getImportPostCodeProgress = async (taskId: string) => {
  try {
    return await axios.get(`${POSTCODE_URL}/progress`, {
      params: { taskId },
    })
  } catch (err) {
    return err
  }
}

export const getActivePostCodeImport = async () => {
  return await axios.get(`${POSTCODE_URL}/active-import`)
}

export const getAllPostCodesForExport = async () => {
  try {
      const response = await axios.get(`${POSTCODE_URL}/export-postcode`)
      return response.data
  } catch (ex) {
      return [null, ex]
  }
}